import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    height: 100%;
    font-size: 16px;
    background-color: #F2F2F3;
    font-family: "Amazon Ember", sans-serif;
    margin: 0;
  }

  html {
    font-family: "Amazon Ember", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
    text-rendering: optimizeLegibility;
  }
`;

export default GlobalStyle;
